export default __webpack_public_path__ + "static/bohdan-52b65fd22c30d619724ce9a887c26255.jpg";